import * as TK from 'components/PDP/Details/components/PasControl/translations/constants';

export const pasCommonLocale = {
  [TK.TITLE]: 'check availability',
  [TK.DELIVERY_METHOD_QUESTION]: 'How would you like to get it?',
  [TK.AVAILABLE_FOR_OTHER_DATES]: 'Available for other dates',
  [TK.AVAILABLE_FOR_OTHER_PRODUCTS]: 'Available for other products',
  [TK.CHANGE_DELIVERY_STORE]:
    'We’ve selected a local store for your delivery based on availability.',
  [TK.CHANGE_STORE]: 'Change Store',
};
